const sha256Hex = async (text) => {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

export const resolveEncodedDataFromVc = async (credential) => {
  if (!credential || typeof credential !== "object") return null;

  const id = typeof credential.id === "string" ? credential.id.trim() : "";
  if (id.startsWith("did")) {
    return id;
  }

  const proof = credential.proof;
  const proofMaterial =
    (typeof proof?.proofValue === "string" && proof.proofValue) ||
    (typeof proof?.jws === "string" && proof.jws) ||
    null;

  if (proofMaterial) {
    const dataHash = await sha256Hex(proofMaterial);
    console.info("Resolved VC encoded_data from proof hash", {
      credentialId: id || null,
      dataHash,
    });
    return dataHash;
  }

  const subjectCredentialId = credential.credentialSubject?.credential_id;
  if (typeof subjectCredentialId === "string" && subjectCredentialId.trim()) {
    return `credissuer:${subjectCredentialId.trim()}`;
  }

  return id || null;
};

export const extractCredentialIdFromVc = (credential) => {
  if (!credential || typeof credential !== "object") return null;
  return typeof credential.id === "string" && credential.id
    ? credential.id
    : null;
};
